import { httpClient } from "@/services";

export default {
	state: {
		settingVersionsListLimit: null,
		settingVersionsListOrder: null,
		settingVersionsListRows: null,
		settingVersionsListSort: null,
		settingVersionsListTotal: null,
		settingVersionsListTotals: null,
		settingVersionsFilters: null,
		settingVersionsEdit: null,
	},
	mutations: {

		updateSettingVersionsList(state, payload) {
			const { limit, order, rows, sort, total } = payload;
			state.settingVersionsListLimit = limit;
			state.settingVersionsListOrder = order;
			state.settingVersionsListRows = rows;
			state.settingVersionsListSort = sort;
			state.settingVersionsListTotal = total;
			state.settingVersionsListTotals = { id: total };
		},
		updateSettingVersionsFilters(state, payload) {
			state.settingVersionsFilters = payload;
		},
		updateEditVersions(state, payload) {
			state.settingVersionsEdit = payload;
		},
	},
	actions: {

		async getSettingVersionsList({ dispatch, commit }, values) {
			try {
				// dispatch('actionPreloader', true);
				const { data } = await httpClient.post('/info/version/list', values);
				if (data && data.status) {
					commit('updateSettingVersionsList', data);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				// dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getSettingVersionsListFilter({ dispatch, commit }, values) {
			try {
				// dispatch('actionPreloader', true);
				const { data } = await httpClient.post('info/version/filters', values);
				if (data && data.filter) {
					commit('updateSettingVersionsFilters', data.filter);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				// dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getSettingVersionsEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/version/${ id }/edit`);
				if (data && data.status) {
					commit('updateEditVersions', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		async deleteSettingVersions({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/version/${ id }`);
				if (data && data.status) {
					dispatch('getSettingVersionsList', {});
					dispatch('setAlert', { type: "success", message: "✅ The record has been successfully deleted." });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onSettingVersionsEdit({ dispatch }, values ) {
			try {
				const { id } = values;
				const { data } = await httpClient.put(`/info/version/${ id }`, values);
				if ( data ) {
					// commit('updateAccountSettings', data);
					console.log('%c [  data  ] ', 'color:#bada55', typeof data, data );

					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onSettingVersionsSave({ dispatch }, values) {
			// dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/info/version", values);
				if ( data ) {
					// commit('updateAccountSettings', data);
					console.log('%c [  data  ] ', 'color:#bada55', typeof data, data );

					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		settingVersionsListLimit: s => s.settingVersionsListLimit,
		settingVersionsListOrder: s => s.settingVersionsListOrder,
		settingVersionsListRows: s => s.settingVersionsListRows,
		settingVersionsListSort: s => s.settingVersionsListSort,
		settingVersionsListTotal: s => s.settingVersionsListTotal,
		settingVersionsListTotals: s => s.settingVersionsListTotals,

		settingVersionsFilters: s => s.settingVersionsFilters,

		settingVersionsEdit: s => s.settingVersionsEdit,
	}
};
